import React from 'react';
import './footer.scss';
import record from '@visit/images/record.png'

function Footer() {
  return (
    <footer className="footer">
        <div className="content-line">
            Copyright © 2016 深圳恒合互联网络科技有限公司. All Rights Reserved
        </div>
        <div className="content-line">
            粤ICP备17067845号 <img src={record}/> 粤公网安备44030402000857号
        </div>
    </footer>
  );
}

export default Footer;
